// Month constants and utilities
export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
] as const;

export type MonthName = typeof MONTHS[number];

// Helper function to get month options for dropdowns
export const getMonthOptions = () => {
  const currentYear = new Date().getFullYear();
  
  return MONTHS.map((month, index) => ({
    label: `${month} ${currentYear}`,
    value: `${currentYear}-${String(index + 1).padStart(2, '0')}`
  }));
};

// Helper function to format month value to readable name
export const formatMonthValue = (monthValue: string): string => {
  const [year, month] = monthValue.split('-');
  const monthIndex = parseInt(month) - 1;
  return `${MONTHS[monthIndex]} ${year}`;
};

// Helper function to get current month value
export const getCurrentMonthValue = (): string => {
  const currentDate = new Date();
  return `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
};
